import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import ServiceNavbar from "../cpa/components/ServiceNavbar";
import "./styles/cpe.scss";

function Cpe() {
  return (
    <>
      {/* banner */}
      <div className="banner">
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.4, default: { ease: "linear" } }}
        >
          <img src="/cpaImg/CPA.jpg" alt="CPA Banner" loading="lazy" />
        </motion.div>

        <div className="cpabannertext dis">
          Becker
          <br />
          CPE
          <br />
          <div className="fs-1 dis">foundational</div>
        </div>
      </div>

      {/* Service Nav */}
      <ServiceNavbar />
      {/* USCPA 有助生涯&職涯規劃 */}
      <div className="container mb100 mt100 cpe" id="cpe-page">
          <img
            alt=""
            className="img_center w-100 mb-5"
            src="/user_upload/art/05/46/546_photo_15754.png"
          />
        <div className="cpe__container">
          <header className="cpe__heroText" aria-label="Becker CPE 方案介紹">
            <h1 className="cpe__heroTitle">Becker CPE 線上進修方案</h1>
            <p className="cpe__heroSub">
              針對持照專業人士的持續進修需求，提供全線上課程（Webcast 直播與 On Demand 隨選），
              協助您依照工作與生活節奏彈性安排學習。
            </p>
            <ul className="cpe__heroPoints">
              <li>兩種方案可選：Select（一年）與 Essentials（90 天）</li>
              <li>課程涵蓋會計、審計、稅務、管理顧問等 NASBA 核心專業</li>
              <li>完成課程即可下載 CPE 完課證書，快速取得學分</li>
            </ul>

            <div className="cpe__ctaRow" aria-label="行動按鈕">
              <a className="cpe__btn cpe__btn--primary" href="#plans">查看方案與價格</a>
              <a className="cpe__btn" href="#what-is-cpe">了解什麼是 CPE</a>
            </div>
          </header>

          <section id="what-is-cpe" className="cpe__section" aria-label="什麼是 CPE">
            <h2 className="cpe__sectionTitle">什麼是 CPE？</h2>
            <p className="cpe__p">
              Continuing Professional Education（簡稱 CPE）是取得美國專業證照後，依各州或協會規定，
              需定期完成的進修課程與學分要求。學習範圍涵蓋財務會計、審計、稅務、道德倫理、資訊系統、
              管理顧問、商業溝通等與產業實務高度相關的內容，並會因法規與產業變動而頻繁更新。
            </p>
            <p className="cpe__p cpe__muted">
              除 CPA 外，CMA、EA 等證照亦通常要求持照者每年累積一定 CPE 學分，以延續資格與頭銜。
            </p>
          </section>

          <section className="cpe__section" aria-label="誰需要 CPE">
            <h2 className="cpe__sectionTitle">誰需要 CPE？</h2>

            <div className="cpe__grid2" role="list">
              <div className="cpe__card" role="listitem" aria-label="已取得專業美國證照者">
                <h3 className="cpe__planName">1) 已取得專業美國證照者</h3>
                <ul className="cpe__list">
                  <li>
                    <strong>CPA：</strong>已持有 active license 且需續會/續照者，須依州別規定累積 CPE 學分，
                    否則可能影響下一張執照核發與效力延續（各州規定不同）。
                  </li>
                  <li><strong>CMA：</strong>持照者通常需每年累積一定 CPE 學分，以延續資格與頭銜。</li>
                  <li><strong>EA：</strong>持照者通常需依週期累積一定 CPE 學分，以延續資格與頭銜。</li>
                </ul>
              </div>

              <div className="cpe__card" role="listitem" aria-label="自我成長型財會人才">
                <h3 className="cpe__planName">2) 自我成長型財會人才</h3>
                <p className="cpe__p">
                  即使不以維持美國 CPA 執照效力為目標，若希望持續精進美國商業環境與財會實務相關知識，
                  也可透過 CPE 系列課程補足技能與產業視野。
                </p>
                <div className="cpe__divider" aria-hidden="true"></div>
                <p className="cpe__p cpe__muted">
                  補充：一般大學/研究所學分不等同 CPE。CPE 著重於實務應用與法規更新，學習型態更接近業界在職訓練。
                </p>
              </div>
            </div>
          </section>

          <section className="cpe__section" aria-label="Becker CPE 優勢">
            <h2 className="cpe__sectionTitle">Becker CPE 課程優勢</h2>
            <ul className="cpe__list">
              <li><strong>內容與產業高度連結：</strong>聚焦 A&amp;A 準則更新、州與聯邦稅務議題、商業倫理等，並依趨勢更新。</li>
              <li><strong>以實務為導向：</strong>課程設計強調實例與概念拆解，協助學員更快落地應用。</li>
              <li><strong>線上學習更有效率：</strong>課程包含講師影音教學，提升理解與吸收效率；完課即可下載證書。</li>
            </ul>
          </section>

          <section id="plans" className="cpe__section" aria-label="方案與價格">
            <h2 className="cpe__sectionTitle">方案與價格</h2>
            <p className="cpe__p cpe__muted">
              兩方案皆可於效期內不限次數使用 Becker 的 Webcast 直播課程與 On Demand 隨選課程；差異主要在使用效期、適用情境與（部分）課程涵蓋州別說明。
            </p>

            <div className="cpe__noteBox" aria-label="方案內容以原文頁面為準">
              <p className="cpe__p mb-2">
                <strong>提醒：</strong>詳細內容依方案原文頁面顯示為準（內含課程目錄）。
              </p>
              <div className="cpe__ctaRow">
                <a
                  className="cpe__btn"
                  href="https://www.becker.com/cpe/catalog/select?v=6711"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  查看 CPE Select 方案 Catalog
                </a>
                <a
                  className="cpe__btn"
                  href="https://www.becker.com/cpe/catalog/essentials-0?v=6726"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  查看 CPE Essentials 方案 Catalog
                </a>
              </div>
            </div>

            <div className="cpe__grid2 mt-3" role="list" aria-label="方案卡片">
              <article className="cpe__card" role="listitem" aria-label="CPE Select 一年方案">
                <div className="cpe__planTop">
                  <h3 className="cpe__planName">CPE Select 一年方案</h3>
                  <span className="cpe__badge">全年無限學習，彈性自主</span>
                </div>

                <p className="cpe__p">
                  訂閱後一年內不限次數使用直播與隨選課程，自由安排進修時間表。
                </p>

                <div className="cpe__price">NT$ 9,500</div>
                <p className="cpe__priceNote">台灣售價；購買後一週內啟用</p>

                <dl className="cpe__kv">
                  <dt>使用效期</dt><dd>12 個月</dd>
                  <dt>課程範圍</dt><dd>會計、審計、稅務、管理顧問等 NASBA 核心專業</dd>
                  <dt>州別/倫理</dt><dd>多數州別（含哥倫比亞特區、波多黎各與關島）的必修會計道德課程</dd>
                  <dt>行為準則</dt><dd>多數州指定之 AICPA Code of Conduct 與 Expanded Version 課程</dd>
                  <dt>進階課程</dt><dd>精選兩門 8 小時進階課程（主題依年度更新）</dd>
                  <dt>適用客群</dt><dd>已取得專業美國證照者；自我成長型財會人才</dd>
                </dl>

                <div className="cpe__ctaRow">
                  <a
                    className="cpe__btn cpe__btn--primary"
                    href="https://www.beckertw.com/registration/plan?parent_id=4"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    立即購買 Select
                  </a>
                </div>
              </article>

              <article className="cpe__card" role="listitem" aria-label="CPE Essentials 90 天方案">
                <div className="cpe__planTop">
                  <h3 className="cpe__planName">CPE Essentials 90 天方案</h3>
                  <span className="cpe__badge">短期內快速精準完成學習</span>
                </div>

                <p className="cpe__p">
                  訂閱後 90 天內不限次數使用直播與隨選課程，適合需要在短期內完成續會/補修者。
                </p>

                <div className="cpe__price">NT$ 7,500</div>
                <p className="cpe__priceNote">台灣售價；購買後一週內啟用</p>

                <dl className="cpe__kv">
                  <dt>使用效期</dt><dd>90 天</dd>
                  <dt>課程範圍</dt><dd>會計、審計、稅務、管理顧問等 NASBA 核心專業</dd>
                  <dt>州別/倫理</dt><dd>多數州別（含關島、加州、德州、華盛頓州）的必修會計道德課程</dd>
                  <dt>行為準則</dt><dd>多數州指定之 AICPA Code of Conduct 與 Expanded Version 課程</dd>
                  <dt>適用客群</dt><dd>需短期內快速補修 CPE 者（如證照即將到期、修足數量即可完成續會）</dd>
                </dl>

                <div className="cpe__ctaRow">
                  <a
                    className="cpe__btn cpe__btn--primary"
                    href="https://www.beckertw.com/registration/plan?parent_id=4"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    立即購買 Essentials
                  </a>
                </div>
              </article>
            </div>

            <div className="cpe__divider" aria-hidden="true"></div>

            <div className="cpe__tableWrap" aria-label="方案比較表">
              <table className="cpe__table">
                <thead>
                  <tr>
                    <th scope="col">比較項目</th>
                    <th scope="col">Select（一年）</th>
                    <th scope="col">Essentials（90 天）</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>使用效期</td>
                    <td>12 個月</td>
                    <td>90 天</td>
                  </tr>
                  <tr>
                    <td>使用方式</td>
                    <td>效期內不限次數使用 Webcast + On Demand</td>
                    <td>效期內不限次數使用 Webcast + On Demand</td>
                  </tr>
                  <tr>
                    <td>課程主軸</td>
                    <td>NASBA 核心專業（會計、審計、稅務、管理顧問等）</td>
                    <td>NASBA 核心專業（會計、審計、稅務、管理顧問等）</td>
                  </tr>
                  <tr>
                    <td>倫理/州別提醒</td>
                    <td>多數州別（含 DC、波多黎各、關島）之必修會計道德課程；含 AICPA 行為準則課程</td>
                    <td>多數州別（含關島、加州、德州、華盛頓州）之必修會計道德課程；含 AICPA 行為準則課程</td>
                  </tr>
                  <tr>
                    <td>特色</td>
                    <td>含精選兩門 8 小時進階課程（主題依年度更新）</td>
                    <td>聚焦短期快速補修</td>
                  </tr>
                  <tr>
                    <td>台灣售價</td>
                    <td>NT$ 9,500</td>
                    <td>NT$ 7,500</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className="cpe__fineprint">
              註：詳細內容依方案原文頁面顯示為準（內含課程目錄）；Premium/進階課程主題與安排每年持續更新；證書發放條件須依 Becker 系統規範完成課程。
            </p>

            <div className="cpe__ctaRow mt-3" aria-label="方案購買快捷">
              <a
                className="cpe__btn cpe__btn--primary"
                href="https://www.beckertw.com/registration/plan?parent_id=4"
                target="_blank"
                rel="noopener noreferrer"
              >
                立即購買
              </a>
            </div>
          </section>

          <section className="cpe__section" aria-label="適用提醒">
            <h2 className="cpe__sectionTitle">適用提醒（購買前請先確認）</h2>
            <div className="cpe__noteBox">
              <p className="cpe__p">
                <strong>各州法規皆不同。</strong>Becker CPE 全系列每年會頻繁動態更新法規項目、產業動態與新知。
                為確保適用，購買前請先確認所屬州別是否有指定必修課程（例如道德倫理類），並依州別檢查 Catalog，
                確認方案內容是否符合需求。
              </p>
              <div className="cpe__ctaRow">
                <a
                  className="cpe__btn cpe__btn--primary"
                  href="https://www.becker.com/cpe/catalog"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  立即閱覽 Catalog 最新 Becker CPE 課程列表
                </a>
              </div>
            </div>
          </section>

          <section className="cpe__section" aria-label="優化學習體驗">
            <h2 className="cpe__sectionTitle">優化學習體驗</h2>
            <ul className="cpe__list">
              <li>課程包含講師影音教學，提升理解與吸收效率，不再只依賴 PDF 閱讀資料。</li>
              <li>完成課程後可立即下載 CPE 完課證書，快速取得學分。</li>
            </ul>
          </section>

          <section className="cpe__section" aria-label="立即購買">
            <h2 className="cpe__sectionTitle">立即購買</h2>
            <p className="cpe__p cpe__muted">
              所有「立即購買」按鈕皆導向同一購買頁面，請於頁面內選擇對應方案。
            </p>
            <div className="cpe__ctaRow">
              <a
                className="cpe__btn cpe__btn--primary"
                href="https://www.beckertw.com/registration/plan?parent_id=4"
                target="_blank"
                rel="noopener noreferrer"
              >
                立即購買（前往購買頁）
              </a>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default Cpe;
